// Annual Hour Tracker - start
export const FETCH_ANNUAL_HOUR_TRACKER_REQUEST = 'FETCH_ANNUAL_HOUR_TRACKER_REQUEST';
export const FETCH_ANNUAL_HOUR_TRACKER_SUCCESS = 'FETCH_ANNUAL_HOUR_TRACKER_SUCCESS';
export const FETCH_ANNUAL_HOUR_TRACKER_FAILURE = 'FETCH_ANNUAL_HOUR_TRACKER_FAILURE';

export const FETCH_ANNUAL_HOUR_TRACKER_DROPDOWN_REQUEST = 'FETCH_ANNUAL_HOUR_TRACKER_DROPDOWN_REQUEST';
export const FETCH_ANNUAL_HOUR_TRACKER_DROPDOWN_SUCCESS = 'FETCH_ANNUAL_HOUR_TRACKER_DROPDOWN_SUCCESS';
export const FETCH_ANNUAL_HOUR_TRACKER_DROPDOWN_FAILURE = 'FETCH_ANNUAL_HOUR_TRACKER_DROPDOWN_FAILURE';

export const FETCH_ANNUAL_WORKLIST_BY_RPCE_REQUEST = 'FETCH_ANNUAL_WORKLIST_BY_RPCE_REQUEST';
export const FETCH_ANNUAL_WORKLIST_BY_RPCE_SUCCESS = 'FETCH_ANNUAL_WORKLIST_BY_RPCE_SUCCESS';
export const FETCH_ANNUAL_WORKLIST_BY_RPCE_FAILURE = 'FETCH_ANNUAL_WORKLIST_BY_RPCE_FAILURE';

export const FETCH_TASK_BY_WORKLIST_REQUEST = 'FETCH_TASK_BY_WORKLIST_REQUEST';
export const FETCH_TASK_BY_WORKLIST_SUCCESS = 'FETCH_TASK_BY_WORKLIST_SUCCESS';
export const FETCH_TASK_BY_WORKLIST_FAILURE = 'FETCH_TASK_BY_WORKLIST_FAILURE';

export const EXPORT_TO_CSV_REQUEST_ANNUAL_HOUR_TRACKER = 'EXPORT_TO_CSV_REQUEST_ANNUAL_HOUR_TRACKER';
export const EXPORT_TO_CSV_SUCCESS_ANNUAL_HOUR_TRACKER = 'EXPORT_TO_CSV_SUCCESS_ANNUAL_HOUR_TRACKER';
export const EXPORT_TO_CSV_FAILURE_ANNUAL_HOUR_TRACKER = 'EXPORT_TO_CSV_FAILURE_ANNUAL_HOUR_TRACKER';

export const REFRESH_ANNUAL_HOUR_TRACKER_REQUEST = 'REFRESH_ANNUAL_HOUR_TRACKER_REQUEST';
export const REFRESH_ANNUAL_HOUR_TRACKER_SUCCESS = 'REFRESH_ANNUAL_HOUR_TRACKER_SUCCESS';
export const REFRESH_ANNUAL_HOUR_TRACKER_FAILURE = 'REFRESH_ANNUAL_HOUR_TRACKER_FAILURE';
// Annual Hour Tracker - end